export default function( stateCapbilities ) {
	const capabilities = stateCapbilities;
	capList.map(cap => { capabilities.push({ name:  cap, value: cap })});
	return { capabilities: capabilities };
}